/**
 * Hoe oud de vastgelegde data van een regeling is.
 *
 * Dit badge is de hele reden dat `sub_regelingen.bron_gecontroleerd_op`
 * bestaat: op 8 september 2026 bleek de seed van 8 april 153 dagen oud te zijn
 * zonder dat het scherm dat liet zien. Een regeling die langer dan
 * `CONTROLE_VERVALTERMIJN_DAGEN` niet is gecontroleerd ziet er hier
 * aantoonbaar anders uit dan een verse.
 */
import { Badge } from '@/components/ui/badge';
import { ShieldCheck, ShieldAlert, ShieldQuestion } from 'lucide-react';
import { bronVersheid, type BronVersheidStatus } from './bron-versheid';

const STIJL: Record<BronVersheidStatus, string> = {
  vers: 'bg-emerald-100 text-emerald-800 hover:bg-emerald-100',
  verouderd: 'bg-amber-100 text-amber-900 hover:bg-amber-100',
  nooit: 'bg-red-100 text-red-800 hover:bg-red-100',
};

const ICOON = {
  vers: ShieldCheck,
  verouderd: ShieldAlert,
  nooit: ShieldQuestion,
};

const KORT: Record<BronVersheidStatus, (dagen: number | null) => string> = {
  vers: dagen => `Bron ${dagen === 0 ? 'vandaag' : `${dagen} d`} gecontroleerd`,
  verouderd: dagen => `Bron ${dagen} dagen oud`,
  nooit: () => 'Bron nooit gecontroleerd',
};

export function BronControleBadge({
  datum,
  vandaag = new Date(),
}: {
  datum: string | null;
  vandaag?: Date;
}) {
  const versheid = bronVersheid(datum, vandaag);
  const Icoon = ICOON[versheid.status];
  return (
    <Badge className={STIJL[versheid.status]} title={versheid.tekst}>
      <Icoon className="h-3.5 w-3.5 mr-1" />
      {KORT[versheid.status](versheid.dagen)}
    </Badge>
  );
}
